import React, { Fragment } from "react";

export default (
  <>
    <path d="M12.07 19a2 2 0 0 1-1.41-.58L.6 8.42a2 2 0 0 1 2.82-2.84l8.64 8.59 8.51-8.58a2 2 0 1 1 2.84 2.82l-9.92 10a2 2 0 0 1-1.42.59z" />
  </>
);
